import { toNote } from '@/lib/link'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export default function PodcastEpisodePreview({
  event,
  className
}: {
  event: Event
  className?: string
}) {
  const { t } = useTranslation()
  const title = useMemo(() => event.tags.find((t) => t[0] === 'title')?.[1], [event])

  return (
    <div className={cn('pointer-events-none', className)}>
      [{t('Podcast episode')}]{' '}
      <a href={toNote(event)} onClick={(e) => e.preventDefault()} className="italic pr-0.5">
        {title}
      </a>
    </div>
  )
}
